import React from 'react';

export const Refresh: React.VoidFunctionComponent<React.SVGProps<SVGSVGElement>> = props => {
	return (
		<svg width="12" height="11" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<path
				d="M0.648438 1.1454V4.14561M0.648438 4.14561H3.64865M0.648438 4.14561L2.9686 1.96545C3.65911 1.27611 4.55494 0.829858 5.52112 0.693921C6.4873 0.557985 7.47149 0.739734 8.3254 1.21178C9.1793 1.68383 9.85667 2.42061 10.2554 3.3111C10.6542 4.20159 10.7527 5.19756 10.5362 6.14893C10.3197 7.1003 9.79992 7.95555 9.0551 8.5858C8.31027 9.21605 7.38079 9.58717 6.4067 9.64323C5.43262 9.6993 4.4667 9.43727 3.65448 8.89663C2.84226 8.356 2.52357 7.77554 2.14855 7.40051"
				stroke="currentColor"
				stroke-width="1.3"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	);
};
